import styled from 'styled-components';
import { Screen } from './types'; // Adjust the import path as necessary
import { breakpoints, spacing } from '@chegg-ui/theme';
var StyledContentWrapper = styled.div.withConfig({
  componentId: "sc-zd7ija-0"
})(["width:375px;margin:auto auto;@media (max-width:375px){width:100%;}@media (min-width:375px) and (max-width:", "){width:375px;}", " .close-button{position:absolute;top:10px;right:10px;cursor:pointer;z-index:500;}"], breakpoints.lg.min, function (_ref) {
  var screen = _ref.screen;
  return screen === Screen.SUCCESS ? "\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    height: 80vh;\n\n    @media (min-width: ".concat(breakpoints.lg.min, ") {\n      width: 600px;\n    }\n  ") : "\n    @media (min-width: ".concat(breakpoints.lg.min, ") {\n      width: 720px;\n    }\n\n    > div:first-child {\n      padding: ").concat(spacing.px32, " ").concat(spacing.px16, ";\n    }\n  ");
});
export default StyledContentWrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/components/WtOneClick/styled.js
// module id = 5230
// module chunks = 11